'use strict';

var helper = require('../helper');

module.exports = {

    pushNewsletterStep1 (sender, effect) {
        if (!sender) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '17',
            'eventname': 'newsletter_start',
            'step': effect,
            'position': sender,
        };

        helper.log('Pushing newsletter submit step1 impression for \'' + sender + '\'!', true);
        helper.push(pushObject);
    },

    pushNewsletterStep2 (location, title, result) {
        if (!location || !title) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '18',
            'eventname': 'newsletter_step',
            'step': 'step2',
            'position': location,
            'text': title
        };

        helper.log('Pushing newsletter submit step2 impression!', true);
        helper.push(pushObject);
    },

    pushNewsletterStep3 (result) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '19',
            'eventname': 'newsletter_subscription',
            'step': 'confirmation',
        };

        helper.log('Pushing newsletter submit step3 impression!', true);
        helper.push(pushObject);
    },

    pushNewsletterUnsubscribe () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '135',
            'eventname': 'newsletter_unsubscribe'
        };

        helper.log('Pushing newsletter unsubsribe', true);
        helper.push(pushObject);
    },

    pushNewsletterError (errorStep, errorType) {
        let pushObject = {
            'event': 'GAevent',
            'eventID': '58',
            'eventname': 'frontend_error',
            'type': 'newsletter',
            'position': errorStep,
            'text': errorType
        };

        helper.push(pushObject);
    }

};
